import React, { useState } from 'react';
import Button from '../../components/common/Button';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const [formStatus, setFormStatus] = useState({
        submitting: false,
        submitted: false,
        error: null
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormStatus({ submitting: true, submitted: false, error: null });

        // Simulate form submission
        setTimeout(() => {
            console.log('Form submitted:', formData);
            setFormStatus({ submitting: false, submitted: true, error: null });
            setFormData({ name: '', email: '', phone: '', subject: '', message: '' });

            // Reset success message after 5 seconds
            setTimeout(() => {
                setFormStatus({ submitting: false, submitted: false, error: null });
            }, 5000);
        }, 1500);
    };

    const contactInfo = [
        {
            icon: <FaEnvelope />,
            title: 'Email',
            value: 'connect.yathartha@gmail.com',
            link: 'mailto:connect.yathartha@gmail.com'
        },
        {
            icon: <FaPhoneAlt />,
            title: 'Phone',
            value: '+91 7218377377',
            link: 'tel:+91 7218377377'
        },
        {
            icon: <FaMapMarkerAlt />,
            title: 'Address',
            value: 'Sangli, Maharashtra, India',
            link: '#'
        }
    ];

    return (
        <div className="contact-page-final">
            {/* Contact Form Section */}
            <section className="contact-form-section-final">
                <div className="container">
                    <div className="contact-grid-final">
                        {/* Left Side - Contact Info */}
                        <div className="contact-info-sidebar-final">
                            <h3>Contact Information</h3>
                            <p className="contact-info-desc-final">Fill out the form and we'll get back to you shortly</p>

                            <div className="contact-info-list-final">
                                {contactInfo.map((info, index) => (
                                    <a
                                        key={index}
                                        href={info.link}
                                        className="contact-info-item-final"
                                    >
                                        <div className="contact-info-icon-final">{info.icon}</div>
                                        <div className="contact-info-details-final">
                                            <h4>{info.title}</h4>
                                            <p>{info.value}</p>
                                        </div>
                                    </a>
                                ))}
                            </div>

                            {/* Map in Sidebar */}
                            <div className="sidebar-map-container">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61094.96076274271!2d74.54290046619134!3d16.85436033550144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc10c8187f060eb%3A0x37911f53cdc1ddb3!2sSangli%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1766388428326!5m2!1sen!2sin"
                                    width="100%"
                                    height="250"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Office Location"
                                ></iframe>
                            </div>
                        </div>

                        {/* Right Side - Contact Form */}
                        <div className="contact-form-container-final">
                            <div className="form-header-final">
                                <h2>Send us a Message</h2>
                                <p>Fill out the form below and we'll get back to you shortly</p>
                            </div>

                            {formStatus.submitted && (
                                <div className="success-alert-final">
                                    <span className="alert-icon-final">✓</span>
                                    <div>
                                        <strong>Message Sent Successfully!</strong>
                                        <p>Thank you for contacting us. We'll respond within 24 hours.</p>
                                    </div>
                                </div>
                            )}

                            <form onSubmit={handleSubmit} className="contact-form-final">
                                <div className="form-row-final">
                                    <div className="form-group-final">
                                        <label htmlFor="name">Full Name *</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            placeholder="John Doe"
                                            className="form-input-final"
                                        />
                                    </div>

                                    <div className="form-group-final">
                                        <label htmlFor="email">Email Address *</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            placeholder="john@example.com"
                                            className="form-input-final"
                                        />
                                    </div>
                                </div>

                                <div className="form-row-final">
                                    <div className="form-group-final">
                                        <label htmlFor="phone">Phone Number</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="+91 98765 43210"
                                            className="form-input-final"
                                        />
                                    </div>

                                    <div className="form-group-final">
                                        <label htmlFor="subject">Subject *</label>
                                        <input
                                            type="text"
                                            id="subject"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                            placeholder="How can we help?"
                                            className="form-input-final"
                                        />
                                    </div>
                                </div>

                                <div className="form-group-final">
                                    <label htmlFor="message">Message *</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="6"
                                        placeholder="Tell us more about your inquiry..."
                                        className="form-input-final"
                                    ></textarea>
                                </div>

                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={formStatus.submitting}
                                    className="submit-button-final"
                                >
                                    {formStatus.submitting ? (
                                        <>
                                            <span className="spinner-final"></span>
                                            Sending...
                                        </>
                                    ) : (
                                        <>
                                            <span>📤</span>
                                            Send Message
                                        </>
                                    )}
                                </Button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
